import { render } from "./DashboardProductTables.vue?vue&type=template&id=695cf7b5&scoped=true"
import script from "./DashboardProductTables.vue?vue&type=script&lang=js"
export * from "./DashboardProductTables.vue?vue&type=script&lang=js"

import "./DashboardProductTables.vue?vue&type=style&index=0&id=695cf7b5&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695cf7b5"]])

export default __exports__